export default __webpack_public_path__ + "static/media/23.b3f1b517.jpg";